/**
 * CDC Channel Status Enum
 *
 * IMPORTANT: CDC operates with "eventual consistency with bulk correction"
 * - Individual events may be skipped on failure (replayId advances before processing)
 * - Bulk sync provides data correctness guarantee
 * - This is intentional: Salesforce CDC doesn't guarantee exactly-once delivery
 */
export enum CDCStatus {
  ACTIVE = "ACTIVE", // CDC is reliable, replayId is updated
  GAP_DETECTED = "GAP_DETECTED", // Data loss detected, bulk sync pending
  RECOVERING = "RECOVERING", // Bulk sync in progress
  DISABLED = "DISABLED", // CDC intentionally disabled (invalid credentials, sync off, etc)
}

/**
 * State semantics:
 *
 * - ACTIVE: CDC is reliable, events are processed and replayId advances
 * - GAP_DETECTED: Salesforce indicated data loss, waiting for lock to start bulk sync
 * - RECOVERING: Bulk sync in progress, CDC events are ignored
 * - DISABLED: CDC is off (user disabled sync, expired credentials, org soft-deleted, etc)
 *
 * Valid transitions:
 * - ACTIVE → GAP_DETECTED (GAP event received)
 * - ACTIVE → DISABLED (user disables sync / credentials expired)
 * - GAP_DETECTED → RECOVERING (bulk sync starts)
 * - RECOVERING → ACTIVE (bulk sync completes successfully)
 * - RECOVERING → DISABLED (critical error / user cancels)
 * - DISABLED → ACTIVE (user re-enables sync / credentials renewed)
 */
